var Marionette = require('backbone.marionette');

var MergeToPersonContactsView = Marionette.View.extend({
    template: require('../../templates/persons/merge-to-person-contacts-view.html'),

    ui: {
        remove: '.remove'
    },

    events: {
        'click @ui.remove': 'onRemoveRow'
    },

    templateContext: function () {
        var that = this;
        return {
            contacts: that.model.get('object').contacts || [],
            getStringified: function(contact) {
                return contact.type + that.delimeter + contact.data + that.delimeter + contact.preferred;
            },
            isMergedContact: function(ctct) {
                return (that.modelCopyAsOriginal.get('object').contacts || []).filter(function(contact) {
                   return _.isEqual(contact, ctct);
                }).length == 0;
            },
            mergeToPersonId: that.getOption('mergeToPersonId'),
            mergeToPersonName: that.getOption('mergeToPersonName')
        }
    },

    initialize: function (options) {
        this.model = options.model;
        this.modelCopyAsOriginal = options.modelCopyAsOriginal;
        this.delimeter = '~~~';
    },

    onRender: function () {
    },

    onRemoveRow: function(event) {
        var stringified = event.target.id;
        var contact = stringified.split(this.delimeter);

        this.triggerMethod('remove:person:contacts:row', {
            type: contact[0],
            data: contact[1],
            preferred: JSON.parse(contact[2])
        });
    }
});

module.exports = MergeToPersonContactsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/merge-to-person-contacts-view.js
// module id = 484
// module chunks = 0